<template>
  <div id="contenedor-editar-detalle-comentario">
    <v-form
      v-model="formularioValido"
      ref="actualizarObservacionDetalle">
      <v-card>
        <v-card-title>
          Comentario Desglose
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle>
            <v-row>
            <v-col>
                <div>
                    <span
                    class="text-caption font-weight-light"
                    style="padding-left: 10px; display: block;"
                    v-if="observacionDetalle.texto">
                    <cortar-texto
                    :texto="observacionDetalle.texto ?
                    observacionDetalle.texto : ''"
                    >
                    </cortar-texto>
                    </span>
                </div>
            </v-col>
            </v-row>
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col>
              <TextArea
                v-model="observacionDetalle.comentarios"
                label="Comentarios"
                rows="10">
              </TextArea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
            </custom-button>
          <custom-button
            @click="guardar"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario "
            :loading="enviandoFormulario"
            >
            </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import mixObservaciones from '../mixObservaciones';

export default {
  name: 'EditarDetalleComentario',
  mixins: [mixObservaciones],
  components: {
    TextArea,
    CustomButton,
    CortarTexto,
  },
  props: {
    detalle: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      contratosSeleccionados: [],
      observacionDetalle: {
        idContrato: this.detalle.idContrato,
        requiereAccion: this.detalle.requiereAccion,
        requiereDocumento: this.detalle.requiereDocumento,
        texto: this.detalle.texto,
        fechaVencimiento: this.detalle.fechaVencimiento,
        enviado: this.detalle.enviado,
        comentarios: this.detalle.comentarios,
      },
    };
  },
  methods: {
    limpiarFormularioDetalle() {
      this.$refs.actualizarObservacionDetalle.reset();
    },
    async guardar() {
      await this.mixActualizarDetalleSoloComentario();
    },
    cerrar() {
      this.limpiarFormularioDetalle();
      this.$emit('cerrar');
    },
  },
};
</script>
